<div class="aeg-address-details">
    <div class="aeg-address-details__address">
        <address v-if="billingAddress" class="flex items-center gap-2 aeg-address-details__address">
            <aeg-icon-location />
            <span :class="{'aeg-address-details__address-unknow': !hasAddress }">{{ billingAddress }}</span>
        </address>
    </div>

    <div class="aeg-address-details__email flex items-center gap-2">
        <aeg-icon-mail />
        <span :class="{'aeg-address-details__email-unknow': !hasEmail }">{{ emailAddress }}</span>
    </div>
</div>
